module.exports = __webpack_public_path__ + "img/eye-young-complete-2-fatty-acids.d0d605a6.jpg";